import React from 'react';

/* Atoms */
import { MaterialIcon } from 'js/components/atoms';

export default function Button(props) {
    const {
        className = '',
        theme,
        tag,
        href,
        target,
        rel,
        text,
        showIcon = true,
        icon = 'arrow_forward',
        iconSize = 24,
        iconPosition = 'left',
        showText = true,
        onClick,
        ...passProps
    } = props;

    const Tag = tag || (href ? 'a' : 'button');
    const additionalAttributes = href ? { href, target, rel: rel || (target === '_blank' ? 'noreferrer noopener' : null) } : {};
    const classNames = [
        'btn',
        theme ? `btn-${theme}` : '',
        className,
    ];

    const IconComponent = icon && showIcon ? (
        <MaterialIcon
            type={icon}
            size={iconSize}
        />
    ) : null;

    return (
        <Tag
            className={classNames.filter((className) => className !== '').join(' ')}
            title={text}
            onClick={onClick}
            {...additionalAttributes}
            {...passProps}
        >
            {iconPosition === 'left' && IconComponent}
            {showText &&
                <span className="btn__text">
                    {text}
                </span>
            }
            {iconPosition === 'right' && IconComponent}
        </Tag>
    );
}
